import React from "react";
import styled from "styled-components";
import { Colors } from "../config/Constants";

type BoxProps = {
  children: React.ReactNode;
  bgColor?: string;
  borderColor?: string;
  boxShadow?: string;
};

const Box = (props: BoxProps) => {
  return (
    <BoxStyled
      bgColor={props.bgColor}
      borderColor={props.borderColor}
      boxShadow={props.boxShadow}
    >
      {props.children}
    </BoxStyled>
  );
};

export default Box;

const BoxStyled = styled.div<BoxProps>`
  padding: 1.25rem 1.5rem;
  background: ${(props) => (props.bgColor ? props.bgColor : Colors.white)};
  border: 1px solid
    ${(props) => (props.borderColor ? props.borderColor : Colors.magnolia)};
  box-shadow: ${(props) =>
    props.boxShadow ? props.boxShadow : "0px 12px 24px rgba(0, 72, 217, 0.05)"};
  border-radius: 0.75rem;
  @media only screen and (max-width: 768px) {
    box-shadow: none;
    border: none;
    border-radius: 0rem;
  }
`;
